import { Injectable } from '@angular/core';
import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { comedorModulo } from '../diccionarios/comedorModulo';
import { Observable } from 'rxjs';
import { DatosColaboradores } from '../models/api.model';


@Injectable({
    providedIn: 'root'
  })
  export class ComedorService {

    urlComedor: string;
    urlNomina: string;
    diccionarioUrl: any;
    constructor(private commom: CommonService,
                private utilServices: UtilsService) {
          this.urlComedor = this.utilServices.getComedor();
          this.urlNomina = this.utilServices.getNomina();
          this.diccionarioUrl = comedorModulo.url.comedor;
    }

    getBuscarColaborador(innTipo: string, innDatobuscar: string ): Observable<DatosColaboradores> {
        return this.commom.peticionGetSinHeader(this.urlComedor + this.diccionarioUrl.buscarEmpleado + innTipo + '/' + innDatobuscar);
    }

    getBuscarColaboradorFavorita(innTipo: string, innDatobuscar: string, codigoComedor: string ): Observable<DatosColaboradores> {
      return this.commom.peticionGetSinHeader(this.urlComedor + this.diccionarioUrl.buscarEmpleado + innTipo + '/' + innDatobuscar + '/' + codigoComedor);
    }

    postMarcacion(innObjeto) {
        //return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.marcacion, innObjeto);
        return this.commom.peticionPostSinHeader(this.urlNomina + this.diccionarioUrl.marcacion, innObjeto);
    }

    // KD: RTI-18955 - Marcación de Jugo adicional. 
    getComedoresLocalidad(){
      let url = this.urlNomina + comedorModulo.url.precios.comedor;
      return this.commom.peticionGetConHeader(url);
    }

    getComidas(){
      let url = this.urlNomina + comedorModulo.url.precios.comidas;
      return this.commom.peticionGetConHeader(url);
    }

    getComidasPrecio(){
      let url = this.urlNomina + comedorModulo.url.precios.precios;
      return this.commom.peticionGetConHeader(url);
    }

    getComidasPreciosxLocalidad(localidad: string){
      let url = this.urlNomina + comedorModulo.url.precios.precios+localidad;
      return this.commom.peticionGetConHeader(url);
    }

    getComidasPreciofindId(query){
      let url = this.urlNomina + comedorModulo.url.precios.precioId;
      return this.commom.peticionGetConHeader(url);
    }

    createComidasPrecios(payload) {
      let url = this.urlNomina + comedorModulo.url.precios.precios;
      return this.commom.peticionPostConHeader(url, payload);
    }
  
    updateComidasPrecios(payload) {
      let url = this.urlNomina + comedorModulo.url.precios.precios;
      return this.commom.peticionPutConHeader(url, payload);
    }

    deleteComidasPrecios(payload) {
      let url = this.urlNomina + comedorModulo.url.precios.precios;
      return this.commom.peticionDeleteConHeader(url, payload);
    }
    /********************** */

    getEmpleadoByCedula(cedula: string){
      let url = this.urlNomina + 'empleado/' + cedula;
      return this.commom.peticionGetConHeader(url);
    }

    getEmpleadosNombresSearch(search: string){
      let url = this.urlNomina + 'empleado/search?nombres=' + search;
      return this.commom.peticionGetConHeader(url);
    }
    
    getEmpleadosNombresSearchByDeparment(search: string, iduser: string){
      let url = this.urlNomina + 'empleado/search?nombres=' + search + '&iduser=' + iduser;
      return this.commom.peticionGetConHeader(url);
    }


    // KD: T30882 Menu diferenciado. Programa nutricional
    getAllEmpleadosDieta(){
      let url = this.urlNomina + comedorModulo.url.menus.programaNutricional;
      return this.commom.peticionGetConHeader(url);
    }

    postEmpleadosDieta(payload){
      return this.commom.peticionPostConHeader(this.urlNomina + comedorModulo.url.menus.programaNutricional, payload);
    }

    deleteEmpleadosDieta(payload){
      return this.commom.peticionDeleteConHeader(this.urlNomina + comedorModulo.url.menus.programaNutricional, payload);
    }

    getTurnos(){
      let url = this.urlNomina + comedorModulo.url.comedor.turno;
      return this.commom.peticionGetConHeader(url);
    }
    /********************** */

  }